<div [formGroup]="Form" class="form-row">
  <div [ngClass]="{ 'form-group col-md-6': !SeparateRow, 'col-md-12': SeparateRow }" class="mb-3">
    <div class="form-floating">
      <select
        (change)="this.getRegionsByCountry($event.target.value)"
        id="Country"
        class="form-select edit-input font-size-14 my-2 rounded"
        name="Country"
        formControlName="Country"
        placeholder="Insert country from the dropdown"
        [ngClass]="{
          'is-invalid': !!Form.controls.Country.errors,
          'select-empty': !Form.controls.Country.value
        }"
        required
      >
        <option value="" selected disabled hidden></option>
        <option *ngFor="let country of countryOptions" [value]="country.CountryName">
          {{ country.DisplayName }}
        </option>
      </select>
      <label for="Country" class="fw-normal">{{ 'edit.shipping.country' | translate }}</label>
    </div>
    <div class="invalid-feedback d-block error-text">
      <div *ngIf="Form.get('Country')?.errors" class="alert alert-danger font-size-10 mb-0 mt-0">
        <div
          class="error-text"
          *ngIf="
            Form.get('Country')?.errors?.required ||
            Form.get('Country')?.errors?.pattern ||
            Form.get('Country')?.errors?.empty ||
            Form.get('Country')?.errors?.whitespace
          "
        >
          *{{ 'form.country.required' | translate }}
        </div>
      </div>
    </div>
  </div>
  <div [ngClass]="{ 'form-group col-md-6': !SeparateRow, 'col-md-12': SeparateRow }" class="mb-3">
    <div class="form-floating" *ngIf="regionOptions.length > 1">
      <select
        id="County"
        class="form-select font-size-14 edit-input my-2 rounded"
        name="county"
        formControlName="County"
        placeholder="Please select state from the dropdown"
        [ngClass]="{
          'is-invalid': !!Form.controls.County.errors,
          'select-empty': !Form.controls.County.value
        }"
        required
      >
        <option value="" selected disabled hidden></option>
        <option *ngFor="let region of regionOptions" value="{{ region.RegionName }}">
          {{ region.DisplayName }}
        </option>
      </select>
      <label for="Country" class="fw-normal">{{ 'edit.shipping.state' | translate }}</label>
    </div>
    <div class="form-floating" *ngIf="regionOptions[0] == null">
      <input
        id="County"
        class="form-control edit-input my-2 bg-edit rounded"
        name="county"
        type="text"
        formControlName="County"
        placeholder="Please select country first"
        [ngClass]="{
          'is-invalid': !!Form.controls.County.errors
        }"
        required
      />
      <label for="Country" class="fw-normal">{{ 'edit.shipping.state' | translate }}</label>
    </div>
    <div class="invalid-feedback d-block error-text">
      <div *ngIf="Form.get('County')?.errors" class="alert alert-danger font-size-10 mb-0 mt-0">
        <div
          class="error-text"
          *ngIf="
            Form.get('County')?.errors?.required || Form.get('County')?.errors?.empty || Form.get('County')?.errors?.whitespace
          "
        >
          <ng-container *ngIf="regionOptions[0] == null"> *{{ 'form.state.required.enter' | translate }} </ng-container>
          <ng-container *ngIf="regionOptions.length > 1"> *{{ 'form.state.required.select' | translate }} </ng-container>
        </div>
        <div class="error-text" *ngIf="Form.get('County')?.errors?.pattern">
          <ng-container *ngIf="regionOptions[0] == null"> *{{ 'form.state.pattern.enter' | translate }} </ng-container>
          <ng-container *ngIf="regionOptions.length > 1"> *{{ 'form.state.pattern.select' | translate }} </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
